__webpack_require__.p = "/wp-content/themes/jamp-pharma/dist/";